import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useI18n } from "../../i18n/LanguageProvider";

export default function DashboardLogin() {
  const { login } = useAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
      navigate("/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : t("dashboard.invalid"));
    } finally {
      setLoading(false);
    }
  };

  const field =
    "w-full rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-3.5 text-base text-white placeholder-white/30 outline-none transition-[border-color] duration-200 focus:border-green";

  return (
    <div className="flex min-h-screen items-center justify-center bg-black px-6" data-testid="dashboard-login">
      <div className="noise pointer-events-none absolute inset-0" />
      <div className="relative w-full max-w-sm">
        <div className="mb-10 text-center">
          <img src="/centauros-logo.png" alt="Centauros" style={{ height: 26, filter: "invert(1)" }} className="mx-auto w-auto" />
          <h1 className="mt-8 text-2xl font-semibold tracking-tight text-white">{t("dashboard.loginTitle")}</h1>
          <p className="mt-2 text-sm text-white/40">{t("dashboard.loginSubtitle")}</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="mb-2 block text-sm font-medium text-white/60">{t("dashboard.email")}</label>
            <input
              type="email"
              className={field}
              data-testid="login-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-white/60">{t("dashboard.password")}</label>
            <input
              type="password"
              className={field}
              data-testid="login-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {error && <p data-testid="login-error" className="text-sm text-red-400">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="focus-ring inline-flex w-full items-center justify-center gap-2 rounded-full brand-gradient px-6 py-3.5 text-base font-medium text-white transition-[opacity,transform] duration-200 hover:opacity-95 active:scale-[0.99] disabled:opacity-60"
          >
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : t("dashboard.signIn")}
          </button>
        </form>
      </div>
    </div>
  );
}
